import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import TitleRow, { TitleAction } from "../../../../shared/components/TitleRow";
import CancelModal from "../../../../shared/components/CancelModal";
import {
    DetailCustomerTitleBar,
    DeleteCustomerModal,
} from "../../../../configs/customer";
import { AuthenticationContext } from "../../../../provider/AuthenticationProvider";
import { ROLE } from "../../../../data/enums";
import { on } from "events";

interface TitleProps {
    title: string;
    data?: any;
    deleteCustomer: Function;
    handleSubmit: Function;
    setValidated: Function;
    onDataChange: Function;
    hasUnsavedChanges: boolean;
    isSaving: boolean;
    onCancelClick: Function;
}

const Title = ({
    title,
    setValidated,
    deleteCustomer,
    handleSubmit,
    data,
    onDataChange,
    hasUnsavedChanges,
    isSaving,
    onCancelClick,
}: TitleProps) => {
    const navigate = useNavigate();
    const {
        user: { role },
    } = useContext(AuthenticationContext);
    const canEdit = [ROLE.MANAGER, ROLE.SALE_STAFF].includes(role);

    const [isOpenCancelModal, setIsOpenCancelModal] = useState(false);

    const handleCancel = () => {
        if (onDataChange) {
            onDataChange();
        }

        if (onCancelClick && hasUnsavedChanges) {
            onCancelClick();
        } else {
            setIsOpenCancelModal(true);
        }
    };

    const titleActions: TitleAction[] = [
        // {
        //     title: DetailCustomerTitleBar.deleteButton,
        //     onClick: () => {
        //         setIsOpenCancelModal(true);
        //     },
        // },
        {
            title: DetailCustomerTitleBar.saveButton,
            isLoading: isSaving,
            onClick: () => {
                setValidated(true);
                handleSubmit();
            },
        },
        {
            title: DetailCustomerTitleBar.createOrderButton,
            variant: "contained",
            onClick: () => {
                navigate("/product-orders/create/", {
                    state: { customer: data },
                });
            },
        },
    ];

    const getTitleActions = () => {
        return canEdit ? titleActions : [];
    };


    return (
        <>
            <TitleRow title={title} actions={getTitleActions()} />
            {isOpenCancelModal && (
                <CancelModal
                    open={isOpenCancelModal}
                    title={DeleteCustomerModal.title}
                    contentText={DeleteCustomerModal.context}
                    handleConfirm={() => navigate("/customers/")}
                    handleClose={() => setIsOpenCancelModal(false)}
                />
            )}
        </>
    );
};

export default Title;
